import { Link } from '@tanstack/react-router'
import { Glass } from '@ui/glass/Glass'
import { AccountsScreen } from '@ui/finance/AccountsScreen'
import { CardsScreen } from '@ui/finance/CardsScreen'
import { Voltar } from '@ui/shell/Voltar'

/**
 * Contas, cartões e categorias numa tela só. **Feia de propósito**: serve para
 * exercitar o modelo, não para ser usada — as telas de verdade são a Fase 4.
 *
 * **Tela empilhada, e não uma quinta aba.** `Docs/04-Design/Navegação.md` diz
 * que a barra tem quatro abas e que ela é a única navegação de primeiro nível;
 * uma quinta contradiria a nota em vez de implementá-la. Empilhada sobre
 * Transações, com o mesmo padrão de voltar de `Settings.tsx` — `canGoBack()`
 * antes de `back()`, porque aberta por link direto esta é a primeira entrada do
 * histórico e o clique não faria nada (decisão 67).
 *
 * **Uma tela para os três cadastros, e não três rotas.** Cada uma seria uma
 * linha nova na tabela de rotas da nota, para desaparecer na Fase 4. Uma só é
 * uma linha, e ela diz o que é: andaime.
 */
export function Cadastros() {
  return (
    <section>
      <div className="mb-2">
        <Voltar para="/transacoes">Transações</Voltar>
      </div>
      <h1 className="titulo mb-4 text-2xl">Cadastros</h1>

      <p className="mb-4 text-sm text-[var(--text-muted)]">
        Tela mínima da Fase 2, feia de propósito: ela existe para exercitar o modelo. As telas de
        verdade chegam na Fase 4.
      </p>

      <Glass level="frost" className="mb-4 p-5">
        <AccountsScreen />
      </Glass>
      <Glass level="frost" className="mb-4 p-5">
        <CardsScreen />
      </Glass>
      <Glass level="frost" className="p-5">
        {/* Um PONTEIRO, e não a tela: ela mudou de casa para
            `/ajustes/categorias` (decisão 234). Duas cópias da mesma
            administração divergiriam, e quem chegasse por aqui não saberia
            qual das duas é a de verdade. */}
        <Link to="/ajustes/categorias" className="block text-sm underline">
          Administrar categorias e subcategorias →
        </Link>
      </Glass>
    </section>
  )
}
